// ----------------------------------------------------------------------------
// Выход из ЛК
// ----------------------------------------------------------------------------





import {accountElements, authElements} from "../auth-common/auth-account-elements.js";

const ttLKLogout = (e) => {
    e?.preventDefault();

    if (authElements.ttAuthBtn) authElements.ttAuthBtn.disabled = true;
    fetch('/oauth/get_data.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({
            logout: 1
        })
    })
        .then(response => {
            if (!response.ok) throw new Error('Сетевая ошибка сервера');
            return response.json();
        })
        .then(data => {
            if (Number(data.RES) === 1) {
                setTimeout(function () {
                    window.location.href = '/myaccount/';
                }, 2000);
            } else {
                accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message g-message--error">Выполнить выход не удалось. Попробуйте позже.</div>');
            }
        })
        .catch(error => {
            console.error('Произошла ошибка при отправке:', error);
            if (authElements.ttAuthBtn) authElements.ttAuthBtn.disabled = false;
        })
    return false;
}

export default ttLKLogout;
